import { render, staticRenderFns } from "./AliexpressAuthorize.vue?vue&type=template&id=d428c43c&scoped=true"
import script from "./AliexpressAuthorize.vue?vue&type=script&lang=js"
export * from "./AliexpressAuthorize.vue?vue&type=script&lang=js"
import style0 from "./AliexpressAuthorize.vue?vue&type=style&index=0&id=d428c43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d428c43c",
  null
  
)

export default component.exports